import React from "react";
import PricingCard from "../components/PricingCard";

const WeddingPortfolio = () => {
  return (
    <>
      <div className="min-h-screen bg-white">
        {/* Hero Section */}
        <section className="text-center py-20 px-5 bg-gradient-to-br from-slate-50 via-white to-teal-50/30 relative overflow-hidden">
          {/* Animated gradient mesh - matching HeroSection */}
          <div className="absolute inset-0 opacity-40">
            <div
              style={{
                backgroundImage: `
                  radial-gradient(circle at 20% 80%, rgba(20, 184, 166, 0.8) 0%, transparent 60%),
                  radial-gradient(circle at 80% 20%, rgba(6, 182, 212, 0.7) 0%, transparent 60%),
                  radial-gradient(circle at 40% 40%, rgba(16, 185, 129, 0.6) 0%, transparent 60%)
                `,
              }}
              className="absolute inset-0"
            ></div>
          </div>

          <div className="max-w-6xl mx-auto relative z-10">
            <h1 className="text-3xl md:text-5xl font-bold mb-5 text-gray-900">
              {shootType}
            </h1>
            <h3 className="text-lg md:text-xl text-teal-600 font-light">{description}</h3>
          </div>
        </section>

        {/* Process Section */}
        <section className="py-20 px-5 bg-white">
          <div className="max-w-6xl mx-auto">
            <div className="max-w-3xl mx-auto mb-16 text-center">
              <p className="text-gray-600 leading-relaxed text-base md:text-lg">
                {introText}
              </p>
            </div>

            <div className="flex flex-col gap-16 md:gap-32 max-w-5xl mx-auto">
              {steps.map((step, index) => (
                <div
                  key={index}
                  className={`flex flex-col md:items-center gap-8 md:gap-12 py-8 md:py-12 ${
                    step.imagePosition === "right"
                      ? "md:flex-row"
                      : "md:flex-row-reverse"
                  }`}
                >
                  <div className="flex-shrink-0 w-full md:w-96 h-96 md:h-[500px] relative mb-8 md:mb-0">
                    <div
                      className={`absolute top-0 ${
                        step.imagePosition === "right" ? "left-0" : "right-0"
                      } w-32 md:w-56 h-full bg-teal-600 rounded-lg z-0`}
                    ></div>
                    <div
                      className={`absolute top-12 md:top-16 ${
                        step.imagePosition === "right" ? "left-8 md:left-16" : "right-8 md:right-16"
                      } w-64 md:w-80 h-96 md:h-[500px] rounded-lg overflow-hidden shadow-2xl z-10 bg-white`}
                    >
                      <img
                        src={step.image}
                        alt={step.title}
                        className="w-full h-full object-cover "
                      />
                    </div>
                  </div>

                  <div className="flex-1">
                    <div className="text-4xl md:text-6xl font-bold text-teal-600 mb-3 md:mb-4">
                      {step.number}
                    </div>
                    <h3 className="text-2xl md:text-3xl font-semibold mb-3 md:mb-4 text-gray-800">
                      {step.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed text-sm md:text-base">
                      {step.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        <div className="bg-gradient-to-r from-teal-500 to-teal-600">
          <h1 className="text-center text-2xl md:text-3xl font-bold py-8 text-white px-4">
            Choose your Ideal Plan
          </h1>
          <PricingCard plans={pricingPlans} category="weddings" />
        </div>
      </div>
    </>
  );
};

const pricingPlans = [
  {
    title: "Shine",
    price: "€400",
    features: [
      "4 Hour Session",
      "Introductory session",
      "100 Edited Photos",
      "Online Gallery",
    ],
  },
  {
    title: "Radiance",
    price: "€500",
    features: [
      "6 Hour Session",
      "Introductory session",
      "Pre-Wedding Shoot",
      "150 Edited Photos",
      "Online Gallery",
    ],
  },
  {
    title: "Glow",
    price: "€750",
    features: [
      "8 Hour Session",
      "Introductory session",
      "Pre-Wedding Shoot",
      "200 Edited Photos",
      "Online Gallery",
      "Photo Album with 10 photos",
    ],
  },
];

const shootType = "Wedding Photography";
const description = "Your love story, beautifully captured";
const introText =
  `Wedding photography is about capturing the magic, emotion, and beauty of your special day. From intimate moments to grand celebrations, I document every precious detail that makes your wedding unique. My approach blends artistic storytelling with candid moments, ensuring that every smile, tear, and celebration is preserved forever. Whether it's an intimate ceremony or a grand celebration, I'm dedicated to creating timeless images that you'll treasure for a lifetime.`;

const steps = [
  {
    number: "01",
    title: "Before the wedding",
    description:
      `We'll start with an introductory session where we discuss your vision, timeline, and special moments you want captured. I'll learn about your love story, preferred photography style, and any specific shots you have in mind. We'll finalize the schedule, locations, and coordinate with your other vendors to ensure seamless coverage. I'll also provide guidance on timeline planning to ensure we capture all the important moments. An advance payment secures your wedding date on my calendar.`,
    image:
      "https://res.cloudinary.com/shaszstudios-photography/image/upload/v1763411121/couple_shot_7_kcpd8r.jpg",
    imagePosition: "right",
  },
  {
    number: "02",
    title: "During the wedding",
    description:
      `On your big day, I'll be there to capture every moment—from getting ready to the final dance. My approach is unobtrusive yet attentive, allowing you to enjoy your celebration while I document the genuine emotions, candid interactions, and beautiful details. I'll guide you through couple portraits with minimal time away from your guests, ensuring natural and romantic images. From the ceremony's emotional moments to the reception's joyful celebrations, every significant moment will be beautifully preserved. I work seamlessly with your timeline, capturing both the planned moments and the unexpected magic that unfolds.`,
    image:
      "https://res.cloudinary.com/shaszstudios-photography/image/upload/v1763243606/wedding_hand_ab2plz.jpg",
    imagePosition: "left",
  },
  {
    number: "03",
    title: "After the wedding",
    description:
      `Within the first week, you'll receive a sneak peek preview of highlights from your wedding day. Based on your chosen package, you can then select your favorite images for detailed editing. I carefully edit each photo to enhance its beauty while maintaining the authentic atmosphere of your day. Your complete gallery of high-resolution edited photos will be delivered within 3-4 weeks through a beautiful online gallery. The final payment is due upon delivery, and you'll have full printing rights to share and print your memories as you wish.`,
    image:
      "https://res.cloudinary.com/shaszstudios-photography/image/upload/v1763246055/weding_couple_ryru7k.jpg",
    imagePosition: "right",
  },
];

export default WeddingPortfolio;
